const UnitedKingdomSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112681)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M4.13436 7.82324C2.56334 9.86723 1.37873 12.2231 0.688965 14.7824H11.0935L4.13436 7.82324Z"
        fill="#0052B4"
      />
      <path
        d="M39.3106 14.7823C38.6209 12.2231 37.4362 9.86723 35.8652 7.82324L28.9062 14.7823H39.3106Z"
        fill="#0052B4"
      />
      <path
        d="M0.688965 25.2188C1.37881 27.778 2.56342 30.1338 4.13436 32.1777L11.0933 25.2188H0.688965Z"
        fill="#0052B4"
      />
      <path
        d="M32.1763 4.13395C30.1324 2.56293 27.7766 1.37832 25.2173 0.688477V11.0929L32.1763 4.13395Z"
        fill="#0052B4"
      />
      <path
        d="M7.82324 35.8652C9.86723 37.4362 12.2231 38.6208 14.7823 39.3106V28.9062L7.82324 35.8652Z"
        fill="#0052B4"
      />
      <path
        d="M14.7822 0.688477C12.223 1.37832 9.86715 2.56293 7.82324 4.13387L14.7822 11.0929V0.688477Z"
        fill="#0052B4"
      />
      <path
        d="M25.2173 39.3106C27.7765 38.6208 30.1324 37.4362 32.1763 35.8652L25.2173 28.9062V39.3106Z"
        fill="#0052B4"
      />
      <path
        d="M28.9062 25.2188L35.8652 32.1778C37.4362 30.1339 38.6209 27.778 39.3106 25.2188H28.9062Z"
        fill="#0052B4"
      />
      <path
        d="M39.8307 17.3913H22.6088H22.6087V0.169297C21.7548 0.058125 20.8841 0 20 0C19.1157 0 18.2452 0.058125 17.3913 0.169297V17.3912V17.3913H0.169297C0.058125 18.2452 0 19.1159 0 20C0 20.8843 0.058125 21.7548 0.169297 22.6087H17.3912H17.3913V39.8307C18.2452 39.9419 19.1157 40 20 40C20.8841 40 21.7548 39.942 22.6087 39.8307V22.6088V22.6087H39.8307C39.9419 21.7548 40 20.8843 40 20C40 19.1159 39.9419 18.2452 39.8307 17.3913Z"
        fill="#D80027"
      />
      <path
        d="M25.2173 25.2169L34.142 34.1416C34.5524 33.7312 34.944 33.3023 35.3176 32.8576L27.6768 25.2168H25.2173V25.2169Z"
        fill="#D80027"
      />
      <path
        d="M14.7822 25.2188H14.782L5.85742 34.1434C6.26773 34.5538 6.69672 34.9454 7.14141 35.319L14.7822 27.678V25.2188Z"
        fill="#D80027"
      />
      <path
        d="M14.7824 14.7823V14.7822L5.85775 5.85742C5.44729 6.26773 5.05572 6.69672 4.68213 7.14141L12.323 14.7823H14.7824V14.7823Z"
        fill="#D80027"
      />
      <path
        d="M25.2173 14.783L34.1421 5.85816C33.7317 5.4477 33.3028 5.05613 32.8581 4.68262L25.2173 12.3235V14.783Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112681">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default UnitedKingdomSvg;
